<div class="card settings-page">
  <div class="action-panel">
    <button
      *appHasRole="['Admin', 'Manager']"
      id="edit-agent-dd"
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2"
      [disabled]="isLoading() || editAgentDetailsModalOpened"
      (click)="editAgent()"
    >
      <i class="icon ic-edit-20"></i>
      <span>Edit Agent Details</span>
    </button>

    @if (agentSettingsFormMenu.length) {
      <div
        *appHasRole="['Admin', 'Manager']"
        ngbDropdown
        class="dropdown"
        [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
      >
        <button
          ngbDropdownToggle
          id="company-actions-dd-3"
          type="button"
          class="btn btn-primary d-flex align-items-center gap-2"
          [disabled]="modalOpened()"
        >
          <span>Form Actions</span>
          <i class="icon ic-select-20"></i>
        </button>

        <div
          ngbDropdownMenu
          aria-labelledby="company-actions-dd-3"
          class="dropdown-menu dropdown-menu-right"
        >
          @for (item of agentSettingsFormMenu; track $index) {
            <div ngbDropdownItem class="dropdown-item">
              <a class="dropdown-button p-2" (click)="item.action()">
                <i class="icon ic-form-20"></i>
                <div class="document">
                  <div class="title">{{ item.title }}</div>
                  <div class="asic-form">{{ item.formName }}</div>
                </div>
              </a>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!--  <button-->
  <!--    *appHasRole="['Admin', 'Manager']"-->
  <!--    id="reset-edge-password-dd"-->
  <!--    type="button"-->
  <!--    class="btn btn-primary d-flex align-items-center gap-2"-->
  <!--    [disabled]="resetEdgePasswordButtonDisabled"-->
  <!--    (click)="resetEdgePassword()"-->
  <!--  >-->
  <!--    <i class="icon ic-key-20"></i>-->
  <!--    <span>Reset EDGE Password</span>-->
  <!--  </button>-->

  <div class="card-body">
    @if (!isLoading()) {
      <div class="agent-info">
        <div class="form-group">
          <label class="title mb-1">Agent Name</label>
          <div class="property">
            <div appCopy>{{ agent.firmName | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">Agent Number</label>
          <div class="property">
            <div appCopy>{{ agent.agentNumber | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">ASIC Contact</label>
          <div class="property">
            <div appCopy>{{ agent.contactPerson | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">Address</label>
          <div class="property">
            <div appCopy>{{ agent.postalAddress.normalizedFullAddress | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">Phone Number</label>
          <div class="property">
            <div appCopy>{{ agent.phone | phone | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">Email Address</label>
          <div class="property">
            <div appCopy>{{ agent.email | defaultValue }}</div>
          </div>
        </div>
      </div>

      <app-divider margin="24px 0"/>

      <div class="edge-info">
        <div class="form-group">
          <label class="title mb-1">EDGE Login</label>
          <div class="property">
            <div appCopy>{{ agent.edgeLogin | defaultValue }}</div>
          </div>
        </div>

        <div class="form-group">
          <label class="title mb-1">EDGE Password</label>
          <div class="property asic-password">
            @if (agent.edgePassword) {
              @if (edgePasswordVisible) {
                {{ agent.edgePassword | defaultValue }}
              } @else {
                ********
              }

              <app-ag-action-icon-button
                [iconClass]="edgePasswordVisible ? 'ic-eye-off-16' : 'ic-eye-16'"
                (action)="edgePasswordVisible = !edgePasswordVisible"
              />
            } @else {
              {{ '' | defaultValue }}
            }
          </div>
        </div>
      </div>
    }

    <app-loader [loading]="isLoading()"/>
  </div>
</div>
